import { ComplexValue } from 'app/types-shared';
import { TextConfigurationItem, TextItemValidation } from './types-store';

export const ACTION = {
  REQUEST_LANGUAGE_OPTIONS: 'TEXT_CONFIGURATION_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'TEXT_CONFIGURATION_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'TEXT_CONFIGURATION_FORM:FAIL_LANGUAGE_OPTIONS',

  REQUEST_TEXT: 'TEXT_CONFIGURATION_FORM:REQUEST_TEXT',
  RECEIVE_TEXT: 'TEXT_CONFIGURATION_FORM:RECEIVE_TEXT',
  FAIL_TEXT: 'TEXT_CONFIGURATION_FORM:FAIL_TEXT',

  REQUEST_DELETE_TEXT: 'TEXT_CONFIGURATION_FORM:REQUEST_DELETE_TEXT',
  RECEIVE_DELETE_TEXT: 'TEXT_CONFIGURATION_FORM:RECEIVE_DELETE_TEXT',
  FAIL_DELETE_TEXT: 'TEXT_CONFIGURATION_FORM:FAIL_DELETE_TEXT',

  REQUEST_SAVE_TEXT: 'TEXT_CONFIGURATION_FORM:REQUEST_SAVE_TEXT',
  RECEIVE_SAVE_TEXT: 'TEXT_CONFIGURATION_FORM:RECEIVE_SAVE_TEXT',
  FAIL_SAVE_TEXT: 'TEXT_CONFIGURATION_FORM:FAIL_SAVE_TEXT',

  CLEAR_FORM: 'TEXT_CONFIGURATION_FORM:CLEAR_FORM',

  UPDATE_TEXT_SET: 'TEXT_CONFIGURATION_FORM:UPDATE_TEXT_SET',
  UPDATE_TEXT_COLLECTION: 'TEXT_CONFIGURATION_FORM:UPDATE_TEXT_COLLECTION',

  CHANGE_TEXT: 'TEXT_CONFIGURATION_FORM:CHANGE_TEXT',
  COPY_TEXT_TO_ALL: 'TEXT_CONFIGURATION_FORM:COPY_TEXT_TO_ALL',

  UPDATE_VALIDATION: 'TEXT_CONFIGURATION_FORM:UPDATE_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class RequestText {
  public type: string = ACTION.REQUEST_TEXT;
  constructor(public textId: number, public textSet: number) { }
}

export class ReceiveText {
  public type: string = ACTION.RECEIVE_TEXT;
  constructor(public textId: number, public textSet: number, public textItem: TextConfigurationItem) { }
}

export class FailText {
  public type: string = ACTION.FAIL_TEXT;
  constructor(public textId: number, public textSet: number) { }
}

export class RequestDeleteText {
  public type: string = ACTION.REQUEST_DELETE_TEXT;
  constructor(public textId: number, public textSet: number) { }
}

export class ReceiveDeleteText {
  public type: string = ACTION.RECEIVE_DELETE_TEXT;
  constructor(public textId: number, public textSet: number) { }
}

export class FailDeleteText {
  public type: string = ACTION.FAIL_DELETE_TEXT;
  constructor(public textId: number, public textSet: number) { }
}

export class RequestSaveText {
  public type: string = ACTION.REQUEST_SAVE_TEXT;
  constructor(public textId: number, public textSet: number) { }
}

export class ReceiveSaveText {
  public type: string = ACTION.RECEIVE_SAVE_TEXT;
  constructor(public textId: number, public textSet: number) { }
}

export class FailSaveText {
  public type: string = ACTION.FAIL_SAVE_TEXT;
  constructor(public textId: number, public textSet: number) { }
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateTextSet {
  public type: string = ACTION.UPDATE_TEXT_SET;
  constructor(public textSet: ComplexValue<number>) { }
}

export class UpdateTextCollection {
  public type: string = ACTION.UPDATE_TEXT_COLLECTION;
  constructor(public textCollection: ComplexValue<number>[]) { }
}

export class ChangeText {
  public type: string = ACTION.CHANGE_TEXT;
  constructor(public languageId: number, public text: string) { }
}

export class CopyTextToAll {
  public type: string = ACTION.COPY_TEXT_TO_ALL;
  constructor(public languageId: number) { }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: TextItemValidation) { }
}
